import Address from "../types/address";

const cleanPostalCode = (address: Address) => {
  let postalCode = address.postalCode;

  // filter out the +4 numbers from the US postal code
  if (address.country === "US") {
    const postalCodeParts = postalCode.split("-");
    if (postalCodeParts.length === 2) {
      postalCode = postalCodeParts[0];
    }
  }
  
  return postalCode;
}

export {cleanPostalCode};
